import cx from "classnames";
import { useRef } from "react";
import { IonLabel, IonModal } from "@ionic/react";

import s from "./WLResponseDialog.module.scss";
import lock from "../../assets/images/lock.png";
import { WLResponseIcon, useWLResponseDialogStore } from "./store";
import { WLButton } from "../../../Common/components/WLButton/WLButton";
import { subscriptionCommonStyles } from "../../../Common/constants/subscriptionConst";

export const WLResponseDialog = () => {
  const modal = useRef<HTMLIonModalElement>(null);
  const [
    isOpen,
    title,
    description,
    icon,
    onConfirmText,
    onConfirm,
    hideDialog,
    reset,
  ] = useWLResponseDialogStore((state) => [
    state.isOpen,
    state.title,
    state.description,
    state.icon,
    state.onConfirmText,
    state.onConfirm,
    state.hideDialog,
    state.reset,
  ]);

  const dismiss = () => {
    modal.current?.dismiss();
    hideDialog();
    reset();
  };

  const getIcon = (icon: WLResponseIcon) => {
    switch (icon) {
      case "lock":
        return <img src={lock} className={s.lock} alt="" loading="lazy" decoding="async" />;

      case "none":
        return <></>;

      default:
        return (
          <div className={s.subscriptionIconContainer}>
            <img
              src={subscriptionCommonStyles[icon ?? "Starter"].cardIcon}
              className={s.subscriptionIcon}
              alt=""
              loading="lazy"
              decoding="async"
            />
          </div>
        );
    }
  };
  return (
    <IonModal
      id="response-dialog"
      className={s.responseDialog}
      backdropDismiss={true}
      ref={modal}
      isOpen={isOpen}
      onDidDismiss={dismiss}
    >
      <div
        className={cx(s.container, {
          [s.noIcon]: icon === "none",
        })}
      >
        {getIcon(icon)}
        <div className={s.modalContent}>
          <IonLabel className="wl-h7 white ion-text-uppercase">
            {title}
          </IonLabel>
          <IonLabel className="wl-body-4 gilroy white ion-padding-vertical">
            {description}
          </IonLabel>

          <WLButton
            onClick={onConfirm}
            className={cx(
              s.proceedBtn,
              "red-submit-button wl-body-6 bold ion-margin-top"
            )}
          >
            {onConfirmText}
          </WLButton>
        </div>
      </div>
    </IonModal>
  );
};
